import DOMPurify from 'dompurify';
import { faq, faqV1 } from '../../routes/api/paths';
import { handleResponse, requestOptions } from '../HandlerService';

const decodeHtmlEntities = (html) => {
  if (!html) return '';
  try {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.innerHTML || '';
  } catch (e) {
    return html;
  }
};

const sanitizeHtml = (html) => DOMPurify.sanitize(html || '', { USE_PROFILES: { html: true } });

export const getFaqs = async ({ lang = 'es' } = {}) => {
  const options = requestOptions('GET', {});
  return fetch(`${faq}?lang=${lang}`, options)
    .then(handleResponse)
    .then(({ data }) => {
      const questions = Array.isArray(data?.questions) ? data.questions : [];
      return questions.map(({ title, content }, index) => {
        const decoded = decodeHtmlEntities(content);
        return {
          id: index,
          question: title || '',
          answerHtml: sanitizeHtml(decoded),
        };
      });
    })
    .catch((error) =>
      Promise.reject({
        status: error?.status || error,
        message: error?.message,
      }),
    );
};

export const updateFaqs = async ({ lang = 'es', questions = [], token = '' } = {}) => {
  const payload = {
    lang,
    questions: Array.isArray(questions)
      ? questions.map(({ title = '', content = '' }) => ({ title, content }))
      : [],
  };

  const options = requestOptions('POST', payload, token);
  return fetch(faqV1, options)
    .then(handleResponse)
    .catch((error) =>
      Promise.reject({
        status: error?.status || error,
        message: error?.message,
      }),
    );
};
